import { cloneDeep } from "lodash";
import storageService from "../../services/storage/storageService";

export const SET_DARK_MODE = "app/global/SET_DARK_MODE";
export const SET_TABLE_ROWS_PER_PAGE = "app/global/SET_TABLE_ROWS_PER_PAGE";
export const PUSH_ACTIVE_NOTIFICATION = "app/global/PUSH_ACTIVE_NOTIFICATION";
export const FILTER_ACTIVE_NOTIFICATIONS = "app/global/FILTER_ACTIVE_NOTIFICATIONS";
export const PUSH_CREATED_TABLE_ROWS_IDS = "app/global/PUSH_CREATED_TABLE_ROWS_IDS";
export const SET_SELECTED_TABLE_ROWS_IDS = "app/global/SET_SELECTED_TABLE_ROWS_IDS";
export const CLEAR_CREATED_TABLE_ROWS_IDS = "app/global/CLEAR_CREATED_TABLE_ROWS_IDS";
export const CLEAR_SELECTED_TABLE_ROWS_IDS = "app/global/CLEAR_SELECTED_TABLE_ROWS_IDS";
const SET_BREADCRUMBS_REDIRECT_URL = "app/consents/SET_BREADCRUMBS_REDIRECT_URL";
const NOTIFICATION_CENTER_ACTIVE_TAB = "app/global/NOTIFICATION_CENTER_ACTIVE_TAB";
const FLEET_MANAGEMENT_ACTIVE_TAB = "app/global/FLEET_MANAGEMENT_ACTIVE_TAB";

const initialState = {
  darkMode: storageService.getIsDarkMode() === "true",
  tableRowsPerPage: {},
  activeNotifications: [],
  createdTableRowsIds: [],
  selectedTableRowsIds: [],
  breadcrumbsRedirectUrl: "",
  notificationCenterActiveTab: "",
  fleetManagementActiveTab: ""
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_DARK_MODE: {
      const clonedState = cloneDeep(state);

      storageService.setIsDarkMode(action.payload.darkMode);

      return { ...clonedState, darkMode: action.payload.darkMode };
    }
    case SET_TABLE_ROWS_PER_PAGE: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        tableRowsPerPage: {
          ...clonedState.tableRowsPerPage,
          [action.payload.tableKey]: action.payload.tableRowsPerPage
        }
      };
    }

    case PUSH_ACTIVE_NOTIFICATION: {
      const clonedState = cloneDeep(state);

      const newActiveNotifications = [...clonedState.activeNotifications];

      if (!newActiveNotifications.some((notification) => notification.id === action.payload.id)) {
        newActiveNotifications.push(action.payload);
      }

      return {
        ...clonedState,
        activeNotifications: newActiveNotifications
      };
    }

    case FILTER_ACTIVE_NOTIFICATIONS: {
      const clonedState = cloneDeep(state);

      const newActiveNotifications = clonedState.activeNotifications.filter((notification) =>
        action.payload.includes(notification.id)
      );

      return {
        ...clonedState,
        activeNotifications: newActiveNotifications
      };
    }

    case PUSH_CREATED_TABLE_ROWS_IDS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        createdTableRowsIds: [...clonedState.createdTableRowsIds, ...action.payload]
      };
    }

    case SET_SELECTED_TABLE_ROWS_IDS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        selectedTableRowsIds: action.payload
      };
    }

    case CLEAR_CREATED_TABLE_ROWS_IDS: {
      const clonedSate = cloneDeep(state);

      return {
        ...clonedSate,
        createdTableRowsIds: []
      };
    }

    case CLEAR_SELECTED_TABLE_ROWS_IDS: {
      const clonedSate = cloneDeep(state);

      return {
        ...clonedSate,
        selectedTableRowsIds: []
      };
    }

    case SET_BREADCRUMBS_REDIRECT_URL: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        breadcrumbsRedirectUrl: action.payload
      };
    }

    case NOTIFICATION_CENTER_ACTIVE_TAB: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        notificationCenterActiveTab: action.payload
      };
    }

    case FLEET_MANAGEMENT_ACTIVE_TAB: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        fleetManagementActiveTab: action.payload
      };
    }

    default: {
      return state;
    }
  }
}

export const setDarkMode = (darkMode) => ({ type: SET_DARK_MODE, payload: { darkMode } });
export const setTableRowsPerPage = (tableKey, tableRowsPerPage) => ({
  type: SET_TABLE_ROWS_PER_PAGE,
  payload: { tableKey: tableKey ?? "default", tableRowsPerPage }
});
export const pushActiveNotification = (notification) => ({
  type: PUSH_ACTIVE_NOTIFICATION,
  payload: notification
});

export const filterActiveNotifications = (activeNotificationIds) => ({
  type: FILTER_ACTIVE_NOTIFICATIONS,
  payload: activeNotificationIds
});

export const pushCreatedTableRowsIds = (rowIds) => ({
  type: PUSH_CREATED_TABLE_ROWS_IDS,
  payload: rowIds
});

export const setSelectedTableRowsIds = (rowIds) => ({
  type: SET_SELECTED_TABLE_ROWS_IDS,
  payload: rowIds
});

export const clearCreatedTableRowsIds = () => ({ type: CLEAR_CREATED_TABLE_ROWS_IDS });

export const clearSelectedTableRowsIds = () => ({ type: CLEAR_SELECTED_TABLE_ROWS_IDS });

export const setBreadcrumbsRedirectUrl = (url) => ({
  type: SET_BREADCRUMBS_REDIRECT_URL,
  payload: url
});

export const setNotificationCenterActiveTab = (activeTab) => ({
  type: NOTIFICATION_CENTER_ACTIVE_TAB,
  payload: activeTab
});

export const setFleetManagementActiveTab = (activeTab) => ({
  type: FLEET_MANAGEMENT_ACTIVE_TAB,
  payload: activeTab
});
